/**
 * 本文件是设置页面的meta标签模块
 * @author 笑三少
 */
const PROJECT_NAME = import.meta.env.VITE_APP_NAME;
export function setMeta(options={}){
  const defaultMeta = {
    charset: 'utf-8',
    viewport: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
    description: '台中实验课时核算系统',
    keywords: '课时核算',
    title:PROJECT_NAME,
    ...options
  }
  setMetaTag({ charset: defaultMeta.charset })
  setMetaTag({ name: 'viewport', content: defaultMeta.viewport })
  setMetaTag({ name: 'description', content: defaultMeta.description })
  setMetaTag({ name: 'keywords', content: defaultMeta.keywords })
  setMetaTag({ name: 'applicable-device', content: 'pc' })
  setMetaTag({ 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' })
  setMetaTag({ 'http-equiv': 'content-type', content: 'no-store, no-cache, must-revalidate, max-age=0' })
  setMetaTag({ name: 'browser-adaptation', content: 'webkit' })
  setMetaTag({ name: 'renderer', content: 'webkit|ie-comp|ie-stand' })
}

// 设置或更新 meta 标签
function setMetaTag(attributes) {
  let selector = ''
  if (attributes.charset) {
    selector = 'meta[charset]'
  } else if (attributes.name) {
    selector = `meta[name="${attributes.name}"]`
  } else if (attributes['http-equiv']) {
    selector = `meta[http-equiv="${attributes['http-equiv']}"]`
  } else if (attributes.property) {
    selector = `meta[property="${attributes.property}"]`
  }
  let meta = document.querySelector(selector)
  if (!meta) {
    meta = document.createElement('meta')
    document.head.appendChild(meta)
  }
  // 设置所有属性
  Object.entries(attributes).forEach(([key, value]) => {
    if (value) {
      meta.setAttribute(key, value)
    }
  })
}
